import {
  Tag as ChakraTag,
  TagLabelProps as ChakraTagLabelProps,
  TagRootProps as ChakraTagProps,
} from '@chakra-ui/react'

interface Props extends ChakraTagProps {
  labelProps?: ChakraTagLabelProps
}

export default function Tag({ labelProps, ...rest }: Props) {
  return (
    <ChakraTag.Root {...rest} width="fit-content" >
      <ChakraTag.Label {...labelProps}>{rest.children}</ChakraTag.Label>
    </ChakraTag.Root>
  )
}
